import React from 'react';
import useStyles from '../Discussions/styles';
import { Box, Hidden } from '@material-ui/core';
import CompaignFilterProvider from '../../providers/CompaignFilterProvider';
import CompaignsList from '../CompaignsList/CompaignsList';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import CompaignDetails from '../CompaignDetails/CompaignDetails';

const Compaigns = () => {
  const { path } = useRouteMatch();

  const classes = useStyles();

  return (
    <CompaignFilterProvider>
      <Box className={classes.wrapper}>
        <Hidden smDown>
          <Route
            path={`${path}/:id?`}
            render={(_) => <CompaignsList compaignId={+_.match.params.id} />}
          />
          <Switch>
            <Route
              path={`${path}/:id`}
              render={(_) => (
                <CompaignDetails compaignId={+_.match.params.id} />
              )}
            />
          </Switch>
        </Hidden>
        <Hidden mdUp>
          <Switch>
            <Route exact path="/compaigns" component={CompaignsList} />
            <Route
              path={`${path}/:id`}
              render={(_) => (
                <CompaignDetails compaignId={+_.match.params.id} />
              )}
            />
          </Switch>
        </Hidden>
      </Box>
    </CompaignFilterProvider>
  );
};

export default Compaigns;
